import { useState } from "react";


export type TLocation = {
    timestamp: number
    coords: TCoordinates
}
  
export type TCoordinates = {
    accuracy: number
    latitude: number
    longitude: number
    altitude: any
    altitudeAccuracy: any
    heading: any
    speed: any
}

export default function useGeoLocation() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [location, setLocation] = useState<TLocation | undefined>(undefined);
    

    const getLocation = () => {
        setIsLoading(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getCoordinates);
        } else {
            console.log("location not enabled")
        }
        setIsLoading(false);
    }

    const getCoordinates = (position: TLocation) => {
        setLocation(position)
    }

    return { location, getLocation, isLoading }
}